import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TweetEmbed from 'react-tweet-embed';
import { getInfluencerProfile } from '../../utils/analytics-service';
import { setAssetPageBackLink } from './actions';
import AnalyticsVideoInfoCard from '../../components/analytics-video-info-card';
import AnalyticsInfluencerCard from '../../components/analytics-influencer-card';
import { getTrackedAsset } from '../../utils/jsonapi-functions/tracked-assets';
import { ENGAGEMENT_SCORE, YOUTUBE, FACEBOOK, INSTAGRAM, TWITTER } from '../../utils/static-configuration';
import { setModal } from '../../actions/modal';
import EngagementScoreModal from '../../components/engagement-score-modal';
import Chart from '../../components/chart';
import Tags from '../../components/tags';
import { formatYoutubeVideoAnalytics, formatInstagramAnalytics, formatFacebookAnalytics } from '../../utils/tracked-asset-helpers';
import { getTrackedAssetAnalytics } from '../../utils/tracked-assets-analytics-service';
import { reportError } from '../../utils/error-handling-service';


class AnalyticsAsset extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      trackedAsset: {},
      campaignTrackedAsset: null,
      budget: '',
      loading: false,
      error: null,
      campaignError: null,
      influencerProfile: null,
    };
  }

  handleBudgetChange = event => {
    this.setState({ budget: event.target.value });
  };

  componentDidMount() {
    const assetId = this.props.routeParams.id;
    this.getTrackedAsset(assetId);
  }

  setBackLink = backLink => {
    this.props.onSetAssetPageBackLink({ backLink });
  }

  navigateBack = () => {
    this.context.router.goBack();
  }

  showModal = docType => () => this.props.onSetModal(docType);

  async getTrackedAsset(assetId) {
    try {
      this.setState({ loading: true });

      const trackedAssets = await getTrackedAsset(assetId);
      const trackedAsset = trackedAssets[0];

      const campaignTrackedAsset = trackedAssets.find(trackedAsset => trackedAsset.campaign && trackedAsset.campaign.id && trackedAsset.discussion && trackedAsset.discussion.id);
      this.setState({ campaignTrackedAsset });

      const trackedAssetAnalytics = await getTrackedAssetAnalytics([trackedAssets[0]]);

      if (trackedAsset.platform === TWITTER) {
        this.setState({ tweet: trackedAsset });
      }

      let analyticsData = null;
      let updatedTrackedAsset = null;
      const { data } = trackedAssetAnalytics[0].response;
      if (data) {
        if (trackedAsset.platform === YOUTUBE) analyticsData = formatYoutubeVideoAnalytics(data);
        if (trackedAsset.platform === INSTAGRAM) analyticsData = formatInstagramAnalytics(data);
        if (trackedAsset.platform === FACEBOOK) analyticsData = formatFacebookAnalytics(data);

        if (analyticsData) {
          updatedTrackedAsset = { ...analyticsData, ...trackedAsset };
          if (!updatedTrackedAsset.campaign && !updatedTrackedAsset.discussion) updatedTrackedAsset.isUserAsset = true;
          this.setState({ trackedAsset: updatedTrackedAsset });
        }
      }

      const influencerProfile = data.influencerId ? await getInfluencerProfile(data.influencerId) : null;
      this.setState({ influencerProfile, loading: false, error: null });
    } catch (error) {
      reportError('GET_CAMPAIGN_TRACKED_ASSET_ERROR', error.message);
      this.setState({ campaignError: error, loading: false });
    }
  }

  render() {
    const { backLink } = this.props;
    const { trackedAsset, budget, influencerProfile, loading, error, campaignTrackedAsset, tweet } = this.state;
    if (!trackedAsset) return null;

    const tweetWrapper = {
      backgroundColor: 'white',
      paddingTop: 50,
      paddingBottom: 50,
      marginTop: 50,
    };

    const platformIconOptions = {
      YOUTUBE: '/icons/youtube-round.svg',
      FACEBOOK: '/icons/facebook-round.svg',
      INSTAGRAM: '/icons/instagram-round.svg',
      SNAPCHAT: '/icons/snapchat-round.svg',
      TWITTER: '/icons/twitter-round.svg',
    };

    if (tweet) {
      return (
        <div className="page">
          <div className="page-content">
            <EngagementScoreModal />
            { !loading && !error &&
              <div className="grid">
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <div className="breadcrumb-bar">
                    <img src="/icons/chevron-left.svg" alt="back to analytics" onClick={() => this.context.router.push('/analytics')} />
                    <h3 onClick={this.navigateBack}>
                      Back to Dashboard
                    </h3>
                  </div>
                </div>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <div className="asset-page-header">
                    <img src={platformIconOptions[tweet.platform]} />
                    <h1>Tweet</h1>
                  </div>

                  <div key={tweet.id} style={tweetWrapper} >
                    <TweetEmbed
                      options={{
                        align: 'center',
                      }}
                      id={tweet.assetId}
                    />
                  </div>

                </div>
              </div>
            }
            { !loading && error &&
              <p>Error: {error}</p>
            }
            { loading &&
              <div className="discussion-preloader">
                <img src="/icons/dyzio-icon.svg" alt="Loading..." />
              </div>
            }
          </div>
        </div>
      );
    }

    return (
      <div className="page">
        <div className="page-content">
          <EngagementScoreModal />
          { !loading && !error &&
            <div className="grid">
              <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                <div className="breadcrumb-bar">
                  <img src="/icons/chevron-left.svg" alt="back to analytics" onClick={() => this.context.router.push('/analytics')} />
                  <h3 onClick={this.navigateBack}>
                    Back to Dashboard
                  </h3>
                </div>
              </div>
              <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                <div className="asset-page-header">
                  <img src={platformIconOptions[trackedAsset.platform]} />
                  <h1>{ trackedAsset.title ? `${trackedAsset.title.slice(0, 25)}...` : 'No title' }</h1>
                </div>
                { campaignTrackedAsset &&
                  <h2>
                    Campaign: <a className="normal" onClick={() => this.context.router.push(`/campaign/${campaignTrackedAsset.campaign.id}`)}>{campaignTrackedAsset.campaign.name}</a> > <a className="normal" onClick={() => this.context.router.push(`/campaign/discussion/${campaignTrackedAsset.discussion.id}`)}>{campaignTrackedAsset.discussion.name}</a>
                  </h2>
                }
              </div>
              { trackedAsset && influencerProfile &&
                <div>
                  <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                    <h5><span className="light">INFLUENCER PROFILE</span></h5>
                  </div>
                  <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                    <AnalyticsInfluencerCard trackedAsset={trackedAsset} influencerProfile={influencerProfile} />
                  </div>
                </div>
              }
              <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                <h5><span className="light">BASIC INFO</span></h5>
              </div>
              <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                { trackedAsset &&
                  <AnalyticsVideoInfoCard trackedAsset={trackedAsset} budget={budget} onBudgetChange={this.handleBudgetChange} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} />
                }
              </div>
              { trackedAsset && trackedAsset.platform === YOUTUBE &&
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h5><span className="light">DETAILED BREAKDOWN</span></h5>
                </div>
              }
              { trackedAsset && trackedAsset.platform === YOUTUBE &&
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <Chart trackedAsset={trackedAsset} />
                </div>
              }
              { trackedAsset && trackedAsset.platform === 'YOUTUBE_COMPLIANCE_CHECK' &&
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h5><span className="light">TOP KEYWORDS</span></h5>
                  <p className="small light">this tag cloud shows the top keywords in the videos comments</p>
                </div>
              }
              { trackedAsset && trackedAsset.platform === 'YOUTUBE_COMPLIANCE_CHECK' &&
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <Tags youtubeVideoId={trackedAsset.assetId} />
                </div>
              }
            </div>
          }
          { !loading && error &&
            <p>Error: {error}</p>
          }
          { loading &&
            <div className="discussion-preloader">
              <img src="/icons/dyzio-icon.svg" alt="Loading..." />
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  backLink: state.analyticsAsset.get('backLink'),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetModal: modalName => dispatch(setModal(modalName)),
    onSetAssetPageBackLink: data => dispatch(setAssetPageBackLink(data)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsAsset);



/** WEBPACK FOOTER **
 ** ./src/containers/analytics-asset/index.js
 **/